import { CheckCircleIcon, QuestionMarkCircleIcon } from '@heroicons/react/20/solid'
import { CheckIcon } from '@heroicons/react/20/solid'
import { Link } from '@remix-run/react'

const team = [
  {
    name: 'Michael Foster',
    role: 'Co-Founder / CTO',
    imageUrl:
      'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80',
  },
  // More people...
]

const tiers = [
  {
    name: 'Regular Experience',
    id: 1,
    href: '',
    priceMonthly: '$45',
    description: 'Basic entry into Colours Explosion',
    features: ['Experience live performances throughout the night!', 'Chance to win Colours Explosion prizes', 'Fete with paint, powder and glow sticks'],
    mostPopular: true,
    price: { monthly: '$45', annually: '$55' },
   
  },
  {
    name: 'Customized Experience',
    id: 2,
    href: '',
    priceMonthly: '$55+',
    description: 'Build the experience you want. Customize your experience with add-ons!',
    features: [
			'Regular Entrance Ticket',
      'Nearby Parking',
      'Backstage Access',
      'Food And Beverages Package',
			'Colours Explosion Cup',
      'Colours Explosion Tote Bag, Bucket Hat and Tee',
      
    ],
    price: { monthly: '$55+', annually: '$65+' },
  },
  {
    name: 'Premium Experience',
    id: 3,
    href: '',
    priceMonthly: '$300',
    description: 'Get a premium experience with all of the essentials at a great price!',
    features: [
      'All addons of Customized Experience',
      'Special prizes by our sponsors',
      'Colours Explosion Sticker',
    ],
    price: { monthly: '$300', annually: '$330' },
  },
]


export default function Tickets() {
  return (

    <>
        <div className="py-2 text-center">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl sm:text-center">
          <p className="mt-2 text-4xl font-bold tracking-tight text-red-600 sm:text-5xl">
            Choose the right ticket package for&nbsp;you
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-8  sm:text-center">
          Tickets include Regular, Customized and Premium Experiences.
        </p>
        <div className="flow-root  pb-2">
        <div className="">
          <div className="mx-auto lg:px-8">
            <div className="mx-auto grid grid-cols-1 gap-8  lg:grid-cols-3">
              {tiers.map((tier) => (
                <div
                  key={tier.id}
                  className="flex flex-col justify-between rounded-3xlp-3 shadow-xl ring-1 ring-gray-900/10"
                >
                  <div>
                    <h3 id={tier.id} className="text-base font-semibold leading-7 text-indigo-600">
                      {tier.name}
                    </h3>
                    <div className="mt-4 flex items-baseline gap-x-2">
                      <span className="text-5xl font-bold tracking-tight">{tier.priceMonthly}</span>
                    </div>
                    <p className="mt-6 text-base leading-7">{tier.description}</p>
                    <ul className="mt-10 space-y-4 text-sm leading-6">
                      {tier.features.map((feature) => (
                        <li key={feature} className="flex gap-x-3">
                          <CheckIcon className="h-6 w-5 flex-none text-indigo-600" aria-hidden="true" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <a
                    href={tier.href}
                    aria-describedby={tier.id}
                    className="mt-8 block rounded-md bg-indigo-600 px-3.5 py-2 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Add To Bag
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
          {/* Order summary */}
          <section
            aria-labelledby="summary-heading"
            className="mt-16 rounded-lg px-4 py-6 sm:p-6 lg:col-span-5 lg:mt-0 lg:p-8"
          >
            <h2 id="summary-heading" className="text-lg font-medium ">
              Order summary
            </h2>

            <dl className="mt-6 space-y-4">
              <div className="flex items-center justify-between">
                <dt className="text-sm ">Subtotal</dt>
                <dd className="text-sm font-medium">$99.00</dd>
              </div>
              <div className="flex items-center justify-between border-t border-gray-200 pt-4">
                <dt className="flex items-center text-sm">
                  <span>Shipping estimate</span>
                  <a href="#" className="ml-2 flex-shrink-0">
                    <span className="sr-only">Learn more about how shipping is calculated</span>
                    <QuestionMarkCircleIcon className="h-5 w-5" aria-hidden="true" />
                  </a>
                </dt>
                <dd className="text-sm font-medium ">$5.00</dd>
              </div>
              <div className="flex items-center justify-between border-t border-gray-200 pt-4">
                <dt className="flex text-sm">
                  <span>Tax estimate</span>
                  <a href="#" className="ml-2 flex-shrink-0 ">
                    <span className="sr-only">Learn more about how tax is calculated</span>
                    <QuestionMarkCircleIcon className="h-5 w-5" aria-hidden="true" />
                  </a>
                </dt>
                <dd className="text-sm font-medium">$8.32</dd>
              </div>
              <div className="flex items-center justify-between border-t border-gray-200 pt-4">
                <dt className="text-base font-medium">Order total</dt>
                <dd className="text-base font-medium">$112.32</dd>
              </div>
            </dl>

            <div className="mt-6">
            <Link to="/colours/bag">
            <button
                type="submit"
                className="rounded-md border border-transparent bg-indigo-600 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50"
              >
                Proceed to Bag
              </button>
            </Link>

            </div>
          </section>
            </div>
      </div>
    </div>

    
    </>

  )
}
